// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as IndexRouteImport } from './routes/index'
import { Route as TeacherIndexRouteImport } from './routes/teacher.index'
import { Route as ParentIndexRouteImport } from './routes/parent.index'
import { Route as OsIndexRouteImport } from './routes/os.index'
import { Route as LearnerIndexRouteImport } from './routes/learner.index'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as TeacherWhiteboardRouteImport } from './routes/teacher.whiteboard'
import { Route as TeacherTutorRouteImport } from './routes/teacher.tutor'
import { Route as TeacherTimetableRouteImport } from './routes/teacher.timetable'
import { Route as TeacherStudioRouteImport } from './routes/teacher.studio'
import { Route as TeacherResourcesRouteImport } from './routes/teacher.resources'
import { Route as TeacherReportsRouteImport } from './routes/teacher.reports'
import { Route as TeacherQuizzesRouteImport } from './routes/teacher.quizzes'
import { Route as TeacherQuestionsRouteImport } from './routes/teacher.questions'
import { Route as TeacherQuestionGeneratorRouteImport } from './routes/teacher.question-generator'
import { Route as TeacherQuestionBankRouteImport } from './routes/teacher.question-bank'
import { Route as TeacherPlannerRouteImport } from './routes/teacher.planner'
import { Route as TeacherMessagesRouteImport } from './routes/teacher.messages'
import { Route as TeacherLiveRouteImport } from './routes/teacher.live'
import { Route as TeacherIntelligenceRouteImport } from './routes/teacher.intelligence'
import { Route as TeacherGradebookRouteImport } from './routes/teacher.gradebook'
import { Route as TeacherGeneratorRouteImport } from './routes/teacher.generator'
import { Route as TeacherExamsRouteImport } from './routes/teacher.exams'
import { Route as TeacherCommsRouteImport } from './routes/teacher.comms'
import { Route as TeacherClassesRouteImport } from './routes/teacher.classes'
import { Route as TeacherBehaviourRouteImport } from './routes/teacher.behaviour'
import { Route as TeacherAttendanceRouteImport } from './routes/teacher.attendance'
import { Route as TeacherAssistantRouteImport } from './routes/teacher.assistant'
import { Route as TeacherAssignmentsRouteImport } from './routes/teacher.assignments'
import { Route as TeacherAssessmentsRouteImport } from './routes/teacher.assessments'
import { Route as SettingsOfflineRouteImport } from './routes/settings.offline'
import { Route as ParentTutorRouteImport } from './routes/parent.tutor'
import { Route as ParentTransportRouteImport } from './routes/parent.transport'
import { Route as ParentTimetableRouteImport } from './routes/parent.timetable'
import { Route as ParentMessagesRouteImport } from './routes/parent.messages'
import { Route as ParentLinkRouteImport } from './routes/parent.link'
import { Route as ParentHomeworkRouteImport } from './routes/parent.homework'
import { Route as ParentFeesRouteImport } from './routes/parent.fees'
import { Route as ParentCompanionRouteImport } from './routes/parent.companion'
import { Route as ParentCommsRouteImport } from './routes/parent.comms'
import { Route as PSlugRouteImport } from './routes/p.$slug'
import { Route as LearnerTwinRouteImport } from './routes/learner.twin'
import { Route as LearnerTutorRouteImport } from './routes/learner.tutor'
import { Route as LearnerTreeRouteImport } from './routes/learner.tree'
import { Route as LearnerSubjectsRouteImport } from './routes/learner.subjects'
import { Route as LearnerRetentionRouteImport } from './routes/learner.retention'
import { Route as LearnerReportsRouteImport } from './routes/learner.reports'
import { Route as LearnerQuizzesRouteImport } from './routes/learner.quizzes'
import { Route as LearnerProgressRouteImport } from './routes/learner.progress'
import { Route as LearnerPortfolioRouteImport } from './routes/learner.portfolio'
import { Route as LearnerOnboardingRouteImport } from './routes/learner.onboarding'
import { Route as LearnerMistakesRouteImport } from './routes/learner.mistakes'
import { Route as LearnerMedalsRouteImport } from './routes/learner.medals'
import { Route as LearnerLiveRouteImport } from './routes/learner.live'
import { Route as LearnerLibraryRouteImport } from './routes/learner.library'
import { Route as LearnerLessonsRouteImport } from './routes/learner.lessons'
import { Route as LearnerKidsRouteImport } from './routes/learner.kids'
import { Route as LearnerHowILearnRouteImport } from './routes/learner.how-i-learn'
import { Route as LearnerGradesRouteImport } from './routes/learner.grades'
import { Route as LearnerFeesRouteImport } from './routes/learner.fees'
import { Route as LearnerDownloadsRouteImport } from './routes/learner.downloads'
import { Route as LearnerCommsRouteImport } from './routes/learner.comms'
import { Route as LearnerCoachRouteImport } from './routes/learner.coach'
import { Route as LearnerAssignmentsRouteImport } from './routes/learner.assignments'
import { Route as LearnerAchievementsRouteImport } from './routes/learner.achievements'
import { Route as AdminStaffRouteImport } from './routes/admin.staff'
import { Route as AdminSchoolDashboardRouteImport } from './routes/admin.school-dashboard'
import { Route as AdminSchoolRouteImport } from './routes/admin.school'
import { Route as AdminReportsRouteImport } from './routes/admin.reports'
import { Route as AdminPredictiveRouteImport } from './routes/admin.predictive'
import { Route as AdminPerformanceRouteImport } from './routes/admin.performance'
import { Route as AdminParentsRouteImport } from './routes/admin.parents'
import { Route as AdminOnboardingRouteImport } from './routes/admin.onboarding'
import { Route as AdminOfflineRouteImport } from './routes/admin.offline'
import { Route as AdminModulesRouteImport } from './routes/admin.modules'
import { Route as AdminLearnersRouteImport } from './routes/admin.learners'
import { Route as AdminLearnerIntelligenceRouteImport } from './routes/admin.learner-intelligence'
import { Route as AdminKnowledgeRouteImport } from './routes/admin.knowledge'
import { Route as AdminIntelligenceRouteImport } from './routes/admin.intelligence'
import { Route as AdminFeesRouteImport } from './routes/admin.fees'
import { Route as AdminExecutiveRouteImport } from './routes/admin.executive'
import { Route as AdminCurriculumReferencesRouteImport } from './routes/admin.curriculum-references'
import { Route as AdminCurriculumRouteImport } from './routes/admin.curriculum'
import { Route as AdminContentQualityRouteImport } from './routes/admin.content-quality'
import { Route as AdminCommsRouteImport } from './routes/admin.comms'
import { Route as AdminCalendarRouteImport } from './routes/admin.calendar'
import { Route as AdminBenchmarkingRouteImport } from './routes/admin.benchmarking'
import { Route as AdminAuditRouteImport } from './routes/admin.audit'
import { Route as AdminAssistantRouteImport } from './routes/admin.assistant'
import { Route as AdminAcademicsRouteImport } from './routes/admin.academics'
import { Route as LearnerPapersPaperIdRouteImport } from './routes/learner.papers.$paperId'
import { Route as TeacherTutorThreadIdRouteImport } from './routes/teacher.tutor.$threadId'
import { Route as TeacherReportsCardsRouteImport } from './routes/teacher.reports.cards'
import { Route as TeacherLiveLibraryRouteImport } from './routes/teacher.live.library'
import { Route as TeacherLiveIdRouteImport } from './routes/teacher.live.$id'
import { Route as ParentTutorThreadIdRouteImport } from './routes/parent.tutor.$threadId'
import { Route as LearnerTutorThreadIdRouteImport } from './routes/learner.tutor.$threadId'
import { Route as LearnerReportsReportIdRouteImport } from './routes/learner.reports.$reportId'
import { Route as LearnerQuizzesQuizIdRouteImport } from './routes/learner.quizzes.$quizId'
import { Route as LearnerLiveLibraryRouteImport } from './routes/learner.live.library'
import { Route as LearnerLiveIdRouteImport } from './routes/learner.live.$id'

const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const TeacherIndexRoute = TeacherIndexRouteImport.update({
            id: '/teacher/',path: '/teacher/',getParentRoute: () => rootRouteImport
          })
const ParentIndexRoute = ParentIndexRouteImport.update({
            id: '/parent/',path: '/parent/',getParentRoute: () => rootRouteImport
          })
const OsIndexRoute = OsIndexRouteImport.update({
            id: '/os/',path: '/os/',getParentRoute: () => rootRouteImport
          })
const LearnerIndexRoute = LearnerIndexRouteImport.update({
            id: '/learner/',path: '/learner/',getParentRoute: () => rootRouteImport
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/admin/',path: '/admin/',getParentRoute: () => rootRouteImport
          })
const TeacherWhiteboardRoute = TeacherWhiteboardRouteImport.update({
            id: '/teacher/whiteboard',path: '/teacher/whiteboard',getParentRoute: () => rootRouteImport
          })
const TeacherTutorRoute = TeacherTutorRouteImport.update({
            id: '/teacher/tutor',path: '/teacher/tutor',getParentRoute: () => rootRouteImport
          })
const TeacherTimetableRoute = TeacherTimetableRouteImport.update({
            id: '/teacher/timetable',path: '/teacher/timetable',getParentRoute: () => rootRouteImport
          })
const TeacherStudioRoute = TeacherStudioRouteImport.update({
            id: '/teacher/studio',path: '/teacher/studio',getParentRoute: () => rootRouteImport
          })
const TeacherResourcesRoute = TeacherResourcesRouteImport.update({
            id: '/teacher/resources',path: '/teacher/resources',getParentRoute: () => rootRouteImport
          })
const TeacherReportsRoute = TeacherReportsRouteImport.update({
            id: '/teacher/reports',path: '/teacher/reports',getParentRoute: () => rootRouteImport
          })
const TeacherQuizzesRoute = TeacherQuizzesRouteImport.update({
            id: '/teacher/quizzes',path: '/teacher/quizzes',getParentRoute: () => rootRouteImport
          })
const TeacherQuestionsRoute = TeacherQuestionsRouteImport.update({
            id: '/teacher/questions',path: '/teacher/questions',getParentRoute: () => rootRouteImport
          })
const TeacherQuestionGeneratorRoute = TeacherQuestionGeneratorRouteImport.update({
            id: '/teacher/question-generator',path: '/teacher/question-generator',getParentRoute: () => rootRouteImport
          })
const TeacherQuestionBankRoute = TeacherQuestionBankRouteImport.update({
            id: '/teacher/question-bank',path: '/teacher/question-bank',getParentRoute: () => rootRouteImport
          })
const TeacherPlannerRoute = TeacherPlannerRouteImport.update({
            id: '/teacher/planner',path: '/teacher/planner',getParentRoute: () => rootRouteImport
          })
const TeacherMessagesRoute = TeacherMessagesRouteImport.update({
            id: '/teacher/messages',path: '/teacher/messages',getParentRoute: () => rootRouteImport
          })
const TeacherLiveRoute = TeacherLiveRouteImport.update({
            id: '/teacher/live',path: '/teacher/live',getParentRoute: () => rootRouteImport
          })
const TeacherIntelligenceRoute = TeacherIntelligenceRouteImport.update({
            id: '/teacher/intelligence',path: '/teacher/intelligence',getParentRoute: () => rootRouteImport
          })
const TeacherGradebookRoute = TeacherGradebookRouteImport.update({
            id: '/teacher/gradebook',path: '/teacher/gradebook',getParentRoute: () => rootRouteImport
          })
const TeacherGeneratorRoute = TeacherGeneratorRouteImport.update({
            id: '/teacher/generator',path: '/teacher/generator',getParentRoute: () => rootRouteImport
          })
const TeacherExamsRoute = TeacherExamsRouteImport.update({
            id: '/teacher/exams',path: '/teacher/exams',getParentRoute: () => rootRouteImport
          })
const TeacherCommsRoute = TeacherCommsRouteImport.update({
            id: '/teacher/comms',path: '/teacher/comms',getParentRoute: () => rootRouteImport
          })
const TeacherClassesRoute = TeacherClassesRouteImport.update({
            id: '/teacher/classes',path: '/teacher/classes',getParentRoute: () => rootRouteImport
          })
const TeacherBehaviourRoute = TeacherBehaviourRouteImport.update({
            id: '/teacher/behaviour',path: '/teacher/behaviour',getParentRoute: () => rootRouteImport
          })
const TeacherAttendanceRoute = TeacherAttendanceRouteImport.update({
            id: '/teacher/attendance',path: '/teacher/attendance',getParentRoute: () => rootRouteImport
          })
const TeacherAssistantRoute = TeacherAssistantRouteImport.update({
            id: '/teacher/assistant',path: '/teacher/assistant',getParentRoute: () => rootRouteImport
          })
const TeacherAssignmentsRoute = TeacherAssignmentsRouteImport.update({
            id: '/teacher/assignments',path: '/teacher/assignments',getParentRoute: () => rootRouteImport
          })
const TeacherAssessmentsRoute = TeacherAssessmentsRouteImport.update({
            id: '/teacher/assessments',path: '/teacher/assessments',getParentRoute: () => rootRouteImport
          })
const SettingsOfflineRoute = SettingsOfflineRouteImport.update({
            id: '/settings/offline',path: '/settings/offline',getParentRoute: () => rootRouteImport
          })
const ParentTutorRoute = ParentTutorRouteImport.update({
            id: '/parent/tutor',path: '/parent/tutor',getParentRoute: () => rootRouteImport
          })
const ParentTransportRoute = ParentTransportRouteImport.update({
            id: '/parent/transport',path: '/parent/transport',getParentRoute: () => rootRouteImport
          })
const ParentTimetableRoute = ParentTimetableRouteImport.update({
            id: '/parent/timetable',path: '/parent/timetable',getParentRoute: () => rootRouteImport
          })
const ParentMessagesRoute = ParentMessagesRouteImport.update({
            id: '/parent/messages',path: '/parent/messages',getParentRoute: () => rootRouteImport
          })
const ParentLinkRoute = ParentLinkRouteImport.update({
            id: '/parent/link',path: '/parent/link',getParentRoute: () => rootRouteImport
          })
const ParentHomeworkRoute = ParentHomeworkRouteImport.update({
            id: '/parent/homework',path: '/parent/homework',getParentRoute: () => rootRouteImport
          })
const ParentFeesRoute = ParentFeesRouteImport.update({
            id: '/parent/fees',path: '/parent/fees',getParentRoute: () => rootRouteImport
          })
const ParentCompanionRoute = ParentCompanionRouteImport.update({
            id: '/parent/companion',path: '/parent/companion',getParentRoute: () => rootRouteImport
          })
const ParentCommsRoute = ParentCommsRouteImport.update({
            id: '/parent/comms',path: '/parent/comms',getParentRoute: () => rootRouteImport
          })
const PSlugRoute = PSlugRouteImport.update({
            id: '/p/$slug',path: '/p/$slug',getParentRoute: () => rootRouteImport
          })
const LearnerTwinRoute = LearnerTwinRouteImport.update({
            id: '/learner/twin',path: '/learner/twin',getParentRoute: () => rootRouteImport
          })
const LearnerTutorRoute = LearnerTutorRouteImport.update({
            id: '/learner/tutor',path: '/learner/tutor',getParentRoute: () => rootRouteImport
          })
const LearnerTreeRoute = LearnerTreeRouteImport.update({
            id: '/learner/tree',path: '/learner/tree',getParentRoute: () => rootRouteImport
          })
const LearnerSubjectsRoute = LearnerSubjectsRouteImport.update({
            id: '/learner/subjects',path: '/learner/subjects',getParentRoute: () => rootRouteImport
          })
const LearnerRetentionRoute = LearnerRetentionRouteImport.update({
            id: '/learner/retention',path: '/learner/retention',getParentRoute: () => rootRouteImport
          })
const LearnerReportsRoute = LearnerReportsRouteImport.update({
            id: '/learner/reports',path: '/learner/reports',getParentRoute: () => rootRouteImport
          })
const LearnerQuizzesRoute = LearnerQuizzesRouteImport.update({
            id: '/learner/quizzes',path: '/learner/quizzes',getParentRoute: () => rootRouteImport
          })
const LearnerProgressRoute = LearnerProgressRouteImport.update({
            id: '/learner/progress',path: '/learner/progress',getParentRoute: () => rootRouteImport
          })
const LearnerPortfolioRoute = LearnerPortfolioRouteImport.update({
            id: '/learner/portfolio',path: '/learner/portfolio',getParentRoute: () => rootRouteImport
          })
const LearnerOnboardingRoute = LearnerOnboardingRouteImport.update({
            id: '/learner/onboarding',path: '/learner/onboarding',getParentRoute: () => rootRouteImport
          })
const LearnerMistakesRoute = LearnerMistakesRouteImport.update({
            id: '/learner/mistakes',path: '/learner/mistakes',getParentRoute: () => rootRouteImport
          })
const LearnerMedalsRoute = LearnerMedalsRouteImport.update({
            id: '/learner/medals',path: '/learner/medals',getParentRoute: () => rootRouteImport
          })
const LearnerLiveRoute = LearnerLiveRouteImport.update({
            id: '/learner/live',path: '/learner/live',getParentRoute: () => rootRouteImport
          })
const LearnerLibraryRoute = LearnerLibraryRouteImport.update({
            id: '/learner/library',path: '/learner/library',getParentRoute: () => rootRouteImport
          })
const LearnerLessonsRoute = LearnerLessonsRouteImport.update({
            id: '/learner/lessons',path: '/learner/lessons',getParentRoute: () => rootRouteImport
          })
const LearnerKidsRoute = LearnerKidsRouteImport.update({
            id: '/learner/kids',path: '/learner/kids',getParentRoute: () => rootRouteImport
          })
const LearnerHowILearnRoute = LearnerHowILearnRouteImport.update({
            id: '/learner/how-i-learn',path: '/learner/how-i-learn',getParentRoute: () => rootRouteImport
          })
const LearnerGradesRoute = LearnerGradesRouteImport.update({
            id: '/learner/grades',path: '/learner/grades',getParentRoute: () => rootRouteImport
          })
const LearnerFeesRoute = LearnerFeesRouteImport.update({
            id: '/learner/fees',path: '/learner/fees',getParentRoute: () => rootRouteImport
          })
const LearnerDownloadsRoute = LearnerDownloadsRouteImport.update({
            id: '/learner/downloads',path: '/learner/downloads',getParentRoute: () => rootRouteImport
          })
const LearnerCommsRoute = LearnerCommsRouteImport.update({
            id: '/learner/comms',path: '/learner/comms',getParentRoute: () => rootRouteImport
          })
const LearnerCoachRoute = LearnerCoachRouteImport.update({
            id: '/learner/coach',path: '/learner/coach',getParentRoute: () => rootRouteImport
          })
const LearnerAssignmentsRoute = LearnerAssignmentsRouteImport.update({
            id: '/learner/assignments',path: '/learner/assignments',getParentRoute: () => rootRouteImport
          })
const LearnerAchievementsRoute = LearnerAchievementsRouteImport.update({
            id: '/learner/achievements',path: '/learner/achievements',getParentRoute: () => rootRouteImport
          })
const AdminStaffRoute = AdminStaffRouteImport.update({
            id: '/admin/staff',path: '/admin/staff',getParentRoute: () => rootRouteImport
          })
const AdminSchoolDashboardRoute = AdminSchoolDashboardRouteImport.update({
            id: '/admin/school-dashboard',path: '/admin/school-dashboard',getParentRoute: () => rootRouteImport
          })
const AdminSchoolRoute = AdminSchoolRouteImport.update({
            id: '/admin/school',path: '/admin/school',getParentRoute: () => rootRouteImport
          })
const AdminReportsRoute = AdminReportsRouteImport.update({
            id: '/admin/reports',path: '/admin/reports',getParentRoute: () => rootRouteImport
          })
const AdminPredictiveRoute = AdminPredictiveRouteImport.update({
            id: '/admin/predictive',path: '/admin/predictive',getParentRoute: () => rootRouteImport
          })
const AdminPerformanceRoute = AdminPerformanceRouteImport.update({
            id: '/admin/performance',path: '/admin/performance',getParentRoute: () => rootRouteImport
          })
const AdminParentsRoute = AdminParentsRouteImport.update({
            id: '/admin/parents',path: '/admin/parents',getParentRoute: () => rootRouteImport
          })
const AdminOnboardingRoute = AdminOnboardingRouteImport.update({
            id: '/admin/onboarding',path: '/admin/onboarding',getParentRoute: () => rootRouteImport
          })
const AdminOfflineRoute = AdminOfflineRouteImport.update({
            id: '/admin/offline',path: '/admin/offline',getParentRoute: () => rootRouteImport
          })
const AdminModulesRoute = AdminModulesRouteImport.update({
            id: '/admin/modules',path: '/admin/modules',getParentRoute: () => rootRouteImport
          })
const AdminLearnersRoute = AdminLearnersRouteImport.update({
            id: '/admin/learners',path: '/admin/learners',getParentRoute: () => rootRouteImport
          })
const AdminLearnerIntelligenceRoute = AdminLearnerIntelligenceRouteImport.update({
            id: '/admin/learner-intelligence',path: '/admin/learner-intelligence',getParentRoute: () => rootRouteImport
          })
const AdminKnowledgeRoute = AdminKnowledgeRouteImport.update({
            id: '/admin/knowledge',path: '/admin/knowledge',getParentRoute: () => rootRouteImport
          })
const AdminIntelligenceRoute = AdminIntelligenceRouteImport.update({
            id: '/admin/intelligence',path: '/admin/intelligence',getParentRoute: () => rootRouteImport
          })
const AdminFeesRoute = AdminFeesRouteImport.update({
            id: '/admin/fees',path: '/admin/fees',getParentRoute: () => rootRouteImport
          })
const AdminExecutiveRoute = AdminExecutiveRouteImport.update({
            id: '/admin/executive',path: '/admin/executive',getParentRoute: () => rootRouteImport
          })
const AdminCurriculumReferencesRoute = AdminCurriculumReferencesRouteImport.update({
            id: '/admin/curriculum-references',path: '/admin/curriculum-references',getParentRoute: () => rootRouteImport
          })
const AdminCurriculumRoute = AdminCurriculumRouteImport.update({
            id: '/admin/curriculum',path: '/admin/curriculum',getParentRoute: () => rootRouteImport
          })
const AdminContentQualityRoute = AdminContentQualityRouteImport.update({
            id: '/admin/content-quality',path: '/admin/content-quality',getParentRoute: () => rootRouteImport
          })
const AdminCommsRoute = AdminCommsRouteImport.update({
            id: '/admin/comms',path: '/admin/comms',getParentRoute: () => rootRouteImport
          })
const AdminCalendarRoute = AdminCalendarRouteImport.update({
            id: '/admin/calendar',path: '/admin/calendar',getParentRoute: () => rootRouteImport
          })
const AdminBenchmarkingRoute = AdminBenchmarkingRouteImport.update({
            id: '/admin/benchmarking',path: '/admin/benchmarking',getParentRoute: () => rootRouteImport
          })
const AdminAuditRoute = AdminAuditRouteImport.update({
            id: '/admin/audit',path: '/admin/audit',getParentRoute: () => rootRouteImport
          })
const AdminAssistantRoute = AdminAssistantRouteImport.update({
            id: '/admin/assistant',path: '/admin/assistant',getParentRoute: () => rootRouteImport
          })
const AdminAcademicsRoute = AdminAcademicsRouteImport.update({
            id: '/admin/academics',path: '/admin/academics',getParentRoute: () => rootRouteImport
          })
const LearnerPapersPaperIdRoute = LearnerPapersPaperIdRouteImport.update({
            id: '/learner/papers/$paperId',path: '/learner/papers/$paperId',getParentRoute: () => rootRouteImport
          })
const TeacherTutorThreadIdRoute = TeacherTutorThreadIdRouteImport.update({
            id: '/$threadId',path: '/$threadId',getParentRoute: () => TeacherTutorRoute
          })
const TeacherReportsCardsRoute = TeacherReportsCardsRouteImport.update({
            id: '/cards',path: '/cards',getParentRoute: () => TeacherReportsRoute
          })
const TeacherLiveLibraryRoute = TeacherLiveLibraryRouteImport.update({
            id: '/library',path: '/library',getParentRoute: () => TeacherLiveRoute
          })
const TeacherLiveIdRoute = TeacherLiveIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => TeacherLiveRoute
          })
const ParentTutorThreadIdRoute = ParentTutorThreadIdRouteImport.update({
            id: '/$threadId',path: '/$threadId',getParentRoute: () => ParentTutorRoute
          })
const LearnerTutorThreadIdRoute = LearnerTutorThreadIdRouteImport.update({
            id: '/$threadId',path: '/$threadId',getParentRoute: () => LearnerTutorRoute
          })
const LearnerReportsReportIdRoute = LearnerReportsReportIdRouteImport.update({
            id: '/$reportId',path: '/$reportId',getParentRoute: () => LearnerReportsRoute
          })
const LearnerQuizzesQuizIdRoute = LearnerQuizzesQuizIdRouteImport.update({
            id: '/$quizId',path: '/$quizId',getParentRoute: () => LearnerQuizzesRoute
          })
const LearnerLiveLibraryRoute = LearnerLiveLibraryRouteImport.update({
            id: '/library',path: '/library',getParentRoute: () => LearnerLiveRoute
          })
const LearnerLiveIdRoute = LearnerLiveIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => LearnerLiveRoute
          })





const LearnerLiveRouteChildren = {
  LearnerLiveIdRoute: LearnerLiveIdRoute,LearnerLiveLibraryRoute: LearnerLiveLibraryRoute
}

const LearnerLiveRouteWithChildren = LearnerLiveRoute._addFileChildren(LearnerLiveRouteChildren)




const LearnerQuizzesRouteChildren = {
  LearnerQuizzesQuizIdRoute: LearnerQuizzesQuizIdRoute
}

const LearnerQuizzesRouteWithChildren = LearnerQuizzesRoute._addFileChildren(LearnerQuizzesRouteChildren)




const LearnerReportsRouteChildren = {
  LearnerReportsReportIdRoute: LearnerReportsReportIdRoute
}

const LearnerReportsRouteWithChildren = LearnerReportsRoute._addFileChildren(LearnerReportsRouteChildren)




const LearnerTutorRouteChildren = {
  LearnerTutorThreadIdRoute: LearnerTutorThreadIdRoute
}

const LearnerTutorRouteWithChildren = LearnerTutorRoute._addFileChildren(LearnerTutorRouteChildren)




const ParentTutorRouteChildren = {
  ParentTutorThreadIdRoute: ParentTutorThreadIdRoute
}

const ParentTutorRouteWithChildren = ParentTutorRoute._addFileChildren(ParentTutorRouteChildren)




const TeacherLiveRouteChildren = {
  TeacherLiveIdRoute: TeacherLiveIdRoute,TeacherLiveLibraryRoute: TeacherLiveLibraryRoute
}

const TeacherLiveRouteWithChildren = TeacherLiveRoute._addFileChildren(TeacherLiveRouteChildren)




const TeacherReportsRouteChildren = {
  TeacherReportsCardsRoute: TeacherReportsCardsRoute
}

const TeacherReportsRouteWithChildren = TeacherReportsRoute._addFileChildren(TeacherReportsRouteChildren)




const TeacherTutorRouteChildren = {
  TeacherTutorThreadIdRoute: TeacherTutorThreadIdRoute
}

const TeacherTutorRouteWithChildren = TeacherTutorRoute._addFileChildren(TeacherTutorRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthRoute: AuthRoute,AdminAcademicsRoute: AdminAcademicsRoute,AdminAssistantRoute: AdminAssistantRoute,AdminAuditRoute: AdminAuditRoute,AdminBenchmarkingRoute: AdminBenchmarkingRoute,AdminCalendarRoute: AdminCalendarRoute,AdminCommsRoute: AdminCommsRoute,AdminContentQualityRoute: AdminContentQualityRoute,AdminCurriculumRoute: AdminCurriculumRoute,AdminCurriculumReferencesRoute: AdminCurriculumReferencesRoute,AdminExecutiveRoute: AdminExecutiveRoute,AdminFeesRoute: AdminFeesRoute,AdminIntelligenceRoute: AdminIntelligenceRoute,AdminKnowledgeRoute: AdminKnowledgeRoute,AdminLearnerIntelligenceRoute: AdminLearnerIntelligenceRoute,AdminLearnersRoute: AdminLearnersRoute,AdminModulesRoute: AdminModulesRoute,AdminOfflineRoute: AdminOfflineRoute,AdminOnboardingRoute: AdminOnboardingRoute,AdminParentsRoute: AdminParentsRoute,AdminPerformanceRoute: AdminPerformanceRoute,AdminPredictiveRoute: AdminPredictiveRoute,AdminReportsRoute: AdminReportsRoute,AdminSchoolRoute: AdminSchoolRoute,AdminSchoolDashboardRoute: AdminSchoolDashboardRoute,AdminStaffRoute: AdminStaffRoute,LearnerAchievementsRoute: LearnerAchievementsRoute,LearnerAssignmentsRoute: LearnerAssignmentsRoute,LearnerCoachRoute: LearnerCoachRoute,LearnerCommsRoute: LearnerCommsRoute,LearnerDownloadsRoute: LearnerDownloadsRoute,LearnerFeesRoute: LearnerFeesRoute,LearnerGradesRoute: LearnerGradesRoute,LearnerHowILearnRoute: LearnerHowILearnRoute,LearnerKidsRoute: LearnerKidsRoute,LearnerLessonsRoute: LearnerLessonsRoute,LearnerLibraryRoute: LearnerLibraryRoute,LearnerLiveRoute: LearnerLiveRouteWithChildren,LearnerMedalsRoute: LearnerMedalsRoute,LearnerMistakesRoute: LearnerMistakesRoute,LearnerOnboardingRoute: LearnerOnboardingRoute,LearnerPortfolioRoute: LearnerPortfolioRoute,LearnerProgressRoute: LearnerProgressRoute,LearnerQuizzesRoute: LearnerQuizzesRouteWithChildren,LearnerReportsRoute: LearnerReportsRouteWithChildren,LearnerRetentionRoute: LearnerRetentionRoute,LearnerSubjectsRoute: LearnerSubjectsRoute,LearnerTreeRoute: LearnerTreeRoute,LearnerTutorRoute: LearnerTutorRouteWithChildren,LearnerTwinRoute: LearnerTwinRoute,PSlugRoute: PSlugRoute,ParentCommsRoute: ParentCommsRoute,ParentCompanionRoute: ParentCompanionRoute,ParentFeesRoute: ParentFeesRoute,ParentHomeworkRoute: ParentHomeworkRoute,ParentLinkRoute: ParentLinkRoute,ParentMessagesRoute: ParentMessagesRoute,ParentTimetableRoute: ParentTimetableRoute,ParentTransportRoute: ParentTransportRoute,ParentTutorRoute: ParentTutorRouteWithChildren,SettingsOfflineRoute: SettingsOfflineRoute,TeacherAssessmentsRoute: TeacherAssessmentsRoute,TeacherAssignmentsRoute: TeacherAssignmentsRoute,TeacherAssistantRoute: TeacherAssistantRoute,TeacherAttendanceRoute: TeacherAttendanceRoute,TeacherBehaviourRoute: TeacherBehaviourRoute,TeacherClassesRoute: TeacherClassesRoute,TeacherCommsRoute: TeacherCommsRoute,TeacherExamsRoute: TeacherExamsRoute,TeacherGeneratorRoute: TeacherGeneratorRoute,TeacherGradebookRoute: TeacherGradebookRoute,TeacherIntelligenceRoute: TeacherIntelligenceRoute,TeacherLiveRoute: TeacherLiveRouteWithChildren,TeacherMessagesRoute: TeacherMessagesRoute,TeacherPlannerRoute: TeacherPlannerRoute,TeacherQuestionBankRoute: TeacherQuestionBankRoute,TeacherQuestionGeneratorRoute: TeacherQuestionGeneratorRoute,TeacherQuestionsRoute: TeacherQuestionsRoute,TeacherQuizzesRoute: TeacherQuizzesRoute,TeacherReportsRoute: TeacherReportsRouteWithChildren,TeacherResourcesRoute: TeacherResourcesRoute,TeacherStudioRoute: TeacherStudioRoute,TeacherTimetableRoute: TeacherTimetableRoute,TeacherTutorRoute: TeacherTutorRouteWithChildren,TeacherWhiteboardRoute: TeacherWhiteboardRoute,AdminIndexRoute: AdminIndexRoute,LearnerIndexRoute: LearnerIndexRoute,OsIndexRoute: OsIndexRoute,ParentIndexRoute: ParentIndexRoute,TeacherIndexRoute: TeacherIndexRoute,LearnerPapersPaperIdRoute: LearnerPapersPaperIdRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)